import Chance from 'chance';

const chance = new Chance();

export const createMonthYear = (minYear = 1980) => ({
  month: chance.d12(),
  year: minYear + chance.d20(),
});

export const createMonthYearPair = (minYear = 1980) => {
  const first = createMonthYear(minYear);
  const secondMonth = (first.month + chance.d12()) % 12;
  const secondYear = first.year + chance.d20();
  const second = { month: secondMonth, year: secondYear };

  return { first, second };
};
